go-md {
  display: block;
  go-banner .icon-col {
    svg {
      width: 1.5rem;
    }
  }
}
